<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-04-25 14:54:41
 * @Description: 设备缺陷
 * @LastEditors: Please set LastEditors
-->
<template>
  <el-table :data="tableData" class="h-100 w-100 p-r-20">
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-form label-position="left" inline class="demo-table-expand">
          <el-form-item label="设备名称:">
            <span>{{ props.row.equpmentName }}</span>
          </el-form-item>
          <el-form-item label="设备编号:">
            <span>{{ props.row.equpmentNumber }}</span>
          </el-form-item>
          <el-form-item label="KKS编码:">
            <span>{{ props.row.KKSNumber }}</span>
          </el-form-item>
          <el-form-item label="缺陷编号:">
            <span>{{ props.row.defectNumber }}</span>
          </el-form-item>
          <el-form-item label="缺陷等级:">
            <span>{{ props.row.defectLevel }}</span>
          </el-form-item>
          <el-form-item label="发现人:">
            <span>{{ props.row.discoverPeople }}</span>
          </el-form-item>
          <el-form-item label="检修部门:">
            <span>{{ props.row.overhaulDepartment }}</span>
          </el-form-item>
          <el-form-item label="状态:">
            <span>{{ props.row.status }}</span>
          </el-form-item>
          <el-form-item label="预计消缺日期:">
            <span>{{ props.row.estimatedVacancyDate }}</span>
          </el-form-item>
          <el-form-item label="缺陷说明:">
            <span>{{ props.row.defectDescription }}</span>
          </el-form-item>
          <el-form-item label="缺陷过程描述:">
            <span>{{ props.row.defectProcessDescription }}</span>
          </el-form-item>
          <el-form-item label="缺陷验收审批对应时间:">
            <span>{{ props.row.defectAcceptanceTime }}</span>
          </el-form-item>
          <el-form-item label="工作单:">
            <span>{{ props.row.workOrders }}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
    <el-table-column label="缺陷编号" prop="defectNumber"></el-table-column>
    <el-table-column label="缺陷说明" prop="defectBriefDescription"></el-table-column>
    <el-table-column label="缺陷等级" prop="defectLevel"></el-table-column>
    <el-table-column label="缺陷状态" prop="status"></el-table-column>
  </el-table>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          equpmentName: '1号机组A循环水泵',
          equpmentNumber: '520033010602000009',
          KKSNumber: '10PAC11AP001',
          defectNumber: '180322',
          defectLevel: '四类',
          discoverPeople: '00875495',
          overhaulDepartment: '',
          defectBriefDescription: '电仪设备其他',
          estimatedVacancyDate: '2020/3/18 0:00:00',
          defectDescription: '循环水变频器室1号和2号旁路柜照明无灯泡',
          defectProcessDescription: '走流程，请验收。',
          defectAcceptanceTime: '2020/3/18 0:00:00',
          workOrders: 'LR110553',
          status: '完成',
        },
        {
          equpmentName: '1号机组A循环水泵',
          equpmentNumber: '520033010602000009',
          KKSNumber: '10PAC11AP001',
          defectNumber: '179531',
          defectLevel: '三类',
          discoverPeople: '00877381',
          overhaulDepartment: '',
          defectBriefDescription: '参数(指示)限额',
          estimatedVacancyDate: '2020/2/24 0:00:00',
          defectDescription: '1号机1号循环水泵入口滤网差压大',
          defectProcessDescription: '循泵滤网已清理，可以投运，申请验收。',
          defectAcceptanceTime: '2020/2/23 0:00:00',
          workOrders: 'QF105591',
          status: '完成',
        },
      ],
    }
  },
}
</script>
<style lang="scss" scoped>

.demo-table-expand {
  font-size: 0;
  label {
    width: 90px;
    color: #99a9bf;
  }
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}

</style>
